import React from 'react'
import useScrollVisibility from 'hooks/useScrollVisibility'

function AboutUs() {
  const [isVisible, sectionRef] = useScrollVisibility('about-section')

  return (
    <section id='quem-somos' ref={sectionRef} className='flex w-full items-center justify-center'>
      <div className='m-4 grid w-11/12 grid-cols-1 gap-16 md:m-8 md:w-10/12 md:grid-cols-2'>
        <div className={`flex flex-col gap-4 ${isVisible ? 'animate-slide-right' : 'opacity-0'}`}>
          <header>
            <h2 className='text-3xl font-semibold uppercase md:text-4xl'>Quem Somos</h2>
          </header>

          <p className='text-justify md:text-xl'>
            Há mais de duas décadas, a Advocacia Macias & Cruz é referência no mundo jurídico. Nossa equipe experiente
            oferece soluções jurídicas eficazes e estratégias personalizadas para empresas e indivíduos.
          </p>

          <p className='text-justify md:text-xl'>
            Nossa equipe é altamente qualificada e está comprometida em proteger seus interesses com soluções jurídicas,
            pautadas na ética e legalidade.
          </p>

          <p className='text-justify md:text-xl'>
            Macias & Cruz Advocacia é especializada na recuperação de ativos empresariais, abrangendo desde ações de
            reintegração de posse até questões complexas de arrendamento mercantil.
          </p>
        </div>

        <div className={`flex flex-col gap-8 ${isVisible ? 'animate-slide-left' : 'opacity-0'}`}>
          <article className='flex flex-col gap-2'>
            <header>
              <h2 className='text-3xl font-semibold uppercase'>Missão</h2>
            </header>
            <p className='text-justify md:text-xl'>
              Oferecer soluções jurídicas completas e integradas, assegurando a eficiência e pontualidade na entrega da
              prestação jurisdicional.
            </p>
          </article>

          <article className='flex flex-col gap-2'>
            <header>
              <h2 className='text-3xl font-semibold uppercase'>Visão</h2>
            </header>
            <p className='text-justify md:text-xl'>
              Ser reconhecida como advocacia parceira de grande relevo, destacando-se pela direção estratégica e
              eficiência nos serviços judiciais, extrajudiciais e de consultoria especializada.
            </p>
          </article>

          <article className='flex flex-col gap-2'>
            <header>
              <h2 className='text-3xl font-semibold uppercase'>Valores</h2>
            </header>
            <p className='text-justify md:text-xl'>
              Agimos sempre com ética e integridade, respeitando os princípios legais e morais em todas as nossas
              interações, em um posicionamento estratégico que reflete nossa dedicação à excelência.
            </p>
          </article>
        </div>
      </div>
    </section>
  )
}

export default AboutUs
